import { firebaseConfig } from "./firebaseConfig";

// Contains Global Configurations
const config = {
  firebase: firebaseConfig,
};

export default config;
